import React, { memo, useState } from 'react';
import { Handle, NodeProps, Position } from 'reactflow';

import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';

import styles from './NodeTypes.module.css';

const EventNode: React.FC<NodeProps> = ({ id, data }) => {

    const [event, setEvent] = useState('');

    const handleChange = (event: SelectChangeEvent) => {
        setEvent(event.target.value as string);
    };

    return (
        <div className={styles.node}>
            <FormControl
                fullWidth
                variant="outlined"
                size="small"
                className="nodrag"
            >
                <InputLabel id="select-event-label">Select Event</InputLabel>
                <Select
                    labelId="select-event-label"
                    id="evemt-select"
                    value={event}
                    label="Select Event"
                    onChange={handleChange}
                >
                    <MenuItem value={10}>Ten</MenuItem>
                    <MenuItem value={20}>Twenty</MenuItem>
                    <MenuItem value={30}>Thirty</MenuItem>
                </Select>
            </FormControl>

            <Handle
                className={styles.handle}
                type="target"
                position={Position.Top}
                isConnectable={false}
            />
            <Handle
                className={styles.handle}
                type="source"
                position={Position.Bottom}
                isConnectable={false}
            />
        </div>
    )
}

export default memo(EventNode)